import { DeleteNotificationByActionDTO } from '@pya-mms/common';
import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { Events } from '../constants';
import { RootState } from '../store';
import useSocket from './useSocket';

/**
 * To notify all the admins of something.
 * @returns
 */
const adminNotificationCreate = async ({ notificationType, notificationTypeId }) => {
  const { data } = await axios.post('/notifications/admin-create', {
    notificationType,
    notificationTypeId,
  });
  return data;
};
const notificationCreate = async ({ userId, notificationType, notificationTypeId }) => {
  const { data } = await axios.post('/notifications/create', {
    userId,
    notificationType,
    notificationTypeId,
  });
  return data;
};

const notificationDelete = async (id: string) => {
  const { data } = await axios.delete('/notifications/delete', { data: { id } });
  return data;
};
const notificationDeleteByAction = async (deleteData: DeleteNotificationByActionDTO) => {
  const { data } = await axios.delete('/notifications/deleteByAction', { data: { ...deleteData } });
  return data;
};

const useNotifications = () => {
  const authUser = useSelector((state: RootState) => state.auth.user);
  const { mutateAsync: createAdminMutation } = useMutation(adminNotificationCreate);
  const { mutateAsync: createMutation } = useMutation(notificationCreate);
  const { mutateAsync: deleteMutation } = useMutation(notificationDelete);
  const { mutateAsync: deleteMutationByAction } = useMutation(notificationDeleteByAction);
  const queryClient = useQueryClient();
  const socket = useSocket();
  const deleteNotificationByAction = async (deleteNotificationDTO: DeleteNotificationByActionDTO) => {
    try {
      const notification = await deleteMutationByAction(deleteNotificationDTO);
      socket.emit(Events.DELETE_NOTIFICATION, notification);
    } catch (err) {
      console.error('Error deleting notification by Action');
      console.error(err);
    }
  };
  /*
    User just uses the ID, maybe update it.
    QueryKey works in tandem with some other component, which we're not using right now.
  */
  const createNotification = async ({
    user,
    notificationType,
    notificationTypeId,
    // Need to get rid of these 2.
    queryKey = [''],
    disableCacheUpdate = false,
  }) => {
    if (user._id === authUser._id) {
      return;
    }

    try {
      const notification = await createMutation({
        userId: user._id,
        notificationType,
        notificationTypeId,
      });
      socket.emit(Events.CREATE_NOTIFICATION, notification);

      // if (disableCacheUpdate) {
      //   return;
      // }

      // queryClient.setQueryData(queryKey, (existingPosts: any) => {
      //   if (!existingPosts.pages) {
      //     return {
      //       ...existingPosts,
      //       notifications: [notification, ...existingPosts.notifications],
      //     };
      //   }

      //   return {
      //     ...existingPosts,
      //     pages: existingPosts.pages.map((posts) => {
      //       return posts.map((post) => {
      //         if (post._id === postId) {
      //           return {
      //             ...post,
      //             author: {
      //               ...post.author,
      //               notifications: [notification, ...post.author.notifications],
      //             },
      //           };
      //         } else {
      //           return post;
      //         }
      //       });
      //     }),
      //   };
      // });
    } catch (error) {
      console.error('An error occurred while creating a notification: ', error);
    }
  };

  const deleteNotification = async ({ id, user, queryKey }) => {
    if (user._id === authUser._id) {
      return;
    }

    try {
      const notification = await deleteMutation(id);
      socket.emit(Events.DELETE_NOTIFICATION, notification);
      queryClient.setQueryData(queryKey, (existingPosts: any) => {
        if (!existingPosts.pages) {
          return {
            ...existingPosts,
            notifications: existingPosts.notifications.filter((n) => n._id !== notification._id),
          };
        }

        return {
          ...existingPosts,
          /*
          pages: existingPosts.pages.map((posts) => {
            return posts.map((post) => {
              if (post._id === postId) {
                return {
                  ...post,
                  author: {
                    ...post.author,
                    notifications: post.author.notifications.filter((n) => n._id !== notification._id),
                  },
                };
              } else {
                return post;
              }
            });
          }),*/
        };
      });
    } catch (error) {
      console.error('An error occurred while deleting a notification: ', error);
    }
  };

  const createAdminNotification = async ({ notificationType, notificationTypeId }) => {
    await createAdminMutation({
      notificationType,
      notificationTypeId,
    });
    // IF this is necesary, return the admins ids, not particularly in favor of it though.
    // socket.emit(Events.CREATE_NOTIFICATION, notification);
  };

  return { createNotification, deleteNotification, deleteNotificationByAction, createAdminNotification };
};

export default useNotifications;
